import React from 'react';
import {ThemeProvider as MuiThemeProvider} from '@material-ui/core/styles';
import { KeyboardDatePicker, DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import CustomDate from 'root/libs/exaforte/react/CustomDate';
import TimePicker from 'rc-time-picker';
import CustomFormInput from './CustomFormInput';
import moment from 'moment';
import 'rc-time-picker/assets/index.css';
import { FieldGroup } from 'root/globals/Form';

export default class CustomDateTimePicker extends CustomFormInput {
    constructor(props) {
        super(props);
        
        this._onChangeTime = this._onChangeTime.bind(this);
    }
    _onChange(value) {
        let current_value = this.props.value;

        if(this.props.timestamp && !_.is_empty(current_value))
            current_value = moment.unix(current_value).format('HH:mm:ss');
        else if(typeof current_value == 'string')
            current_value = moment(current_value).format('HH:mm:ss');
        else
            current_value = '00:00:00';

        if(value)
        {
            if(value.isValid())
            {
                value = value.format('YYYY-MM-DD') + ' ' + current_value;
    
                if(this.props.timestamp)
                    this.props.onChangeText(moment(value).unix());
                else
                    this.props.onChangeText(value);
            }
        }
        else
            this.props.onChangeText(null);
    }
    
    _onChangeTime(value) {
        let current_value = this.props.value;
        
        if(this.props.timestamp && !_.is_empty(current_value))
            current_value = moment.unix(current_value);
        if(typeof current_value == 'string')
            current_value = moment(current_value);
        
        if(value)
        {
            value = current_value.format('YYYY-MM-DD') + ' ' + value.format('HH:mm:ss');

            if(this.props.timestamp)
                this.props.onChangeText(moment(value).unix());
            else
                this.props.onChangeText(value);
        }
        else
            this.props.onChangeText(null);
    }
    
    getElement() {
        let props                   = this.getSupportedProps();
        let Picker                  = (typeof this.props.allowKeyboard == 'undefined' || this.props.allowKeyboard ? KeyboardDatePicker : DatePicker);
        props.variant               = props.variant || 'inline';
        props.invalidDateMessage    = props.invalidDateMessage || '';
        
        if(props.variant != 'inline')
            props.cancelLabel = props.cancelLabel || 'Annuleren';
        
        if(!props.format)
            props.format = 'DD-MM-YYYY';

        if(this.props.timestamp && !_.is_empty(props.value))
            props.value = moment.unix(props.value);
        else if(typeof props.value == 'string')
            props.value = new CustomDate(props.value);

        return <FieldGroup row={true} style={{marginBottom: 0}}><Picker onChange={this._onChange} InputProps={{ disableUnderline: true }} style={{flex: 4}} {...props} />{this.getTimeElement()}</FieldGroup>;
    }

    getTimeElement() {
        let props           = this.getSupportedProps();
        props.format        = props.format || 'HH:mm';
        props.showSecond    = typeof props.showSecond == 'undefined' ? false : props.showSecond;
        props.onOpen        = () => this.setState({isFocused: true});
        props.onClose       = () => this.setState({isFocused: false});
        
        if(!_.is_empty(props.value))
        {
            if(this.props.timestamp)
                props.value = moment.unix(props.value);
            else
                props.value = moment(props.value);
        }
        else
            props.value = null;

        return <TimePicker getPopupContainer={node => node} allowEmpty={(this.props.mandatory ? false : true)} onChange={this._onChangeTime} {...props} />;
    }
    
    render() {
        let datepicker = (<MuiPickersUtilsProvider utils={MomentUtils} locale={'nl'}>{super.render()}</MuiPickersUtilsProvider>);
            
        if(!this.props.theme)
            return datepicker;

        return (<MuiThemeProvider theme={this.props.theme}>
            {datepicker}
        </MuiThemeProvider>);
    }
}